/* istanbul ignore file */
import { ProjectToolMessageCallback } from 'domain/projects/shared/projectToolsCreation';

const useCreateRedmineProjectResponseHandler = () => {
  const handleCreateProject = (creationStatus: any, callback: ProjectToolMessageCallback) => {
    if (creationStatus.status === 'OK') {
      callback({
        type: 'log',
        level: 'success',
        message: `Successfully created Redmine project with Identifier: ${creationStatus.identifier}.`,
      });
      return true;
    } else if (creationStatus.status === 'ERROR') {
      callback({ type: 'log', level: 'error', message: `Failed to create Redmine project.` });
    }
    return false;
  };

  const handleDavinciProjectUpdateStatus = (davinciProjectStatus: any, callback: ProjectToolMessageCallback) => {
    if (davinciProjectStatus.status === 'OK') {
      callback({
        type: 'log',
        level: 'success',
        message: `Successfully updated project with adding Redmine project alias.`,
      });
      return true;
    } else if (davinciProjectStatus.status === 'ERROR') {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to update project with adding Redmine project alias. ${davinciProjectStatus.errors.join(' ')}.`,
      });
    }
    return false;
  };

  const handleAddMembership = (addMembershipStatus: any, callback: ProjectToolMessageCallback) => {
    if (addMembershipStatus.status === 'OK') {
      callback({
        type: 'log',
        level: 'success',
        message: `Successfully added membership for user: ${addMembershipStatus.name}.`,
      });
      return true;
    } else if (addMembershipStatus.status === 'ERROR') {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to add membership for user: ${addMembershipStatus.name}. ${addMembershipStatus.errors.join(' ')}.`,
      });
    }
    return false;
  };

  const handleCreateProjectResponse = (state: any, callback: ProjectToolMessageCallback) => {
    let isPassed = true;
    let isWarning = false;

    if (state.projectCreationStatus) {
      isPassed = handleCreateProject(state.projectCreationStatus, callback) && isPassed;
    }
    if (state.davinciProjectStatus) {
      isPassed = handleDavinciProjectUpdateStatus(state.davinciProjectStatus, callback) && isPassed;
    }
    if (state.addMembershipStatusList) {
      state.addMembershipStatusList.forEach((addMembershipStatus: any) => {
        isWarning = !handleAddMembership(addMembershipStatus, callback) && isWarning;
      });
    }

    callback({ type: 'status', status: isPassed ? (isWarning ? 'warning' : 'passed') : 'failed' });
  };

  return {
    handleCreateProjectResponse,
  };
};

export default useCreateRedmineProjectResponseHandler;
